/* ------------------- IMPORTS */
import PostV2 from 'api/PostV2'
import { Tracker } from 'api/Tracker'
import { HandleSelectCard } from 'components/UI'
import { useCalendarStore } from 'stores/CalendarStore'
import { showSuccess, T } from 'utils'
import { getMixpanelPostDeletedDataSmall, TRACKEREVENTS } from 'utils/eventsTracker'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */

interface Props {}

export const CalendarFooter = ({}: Props) => {
  /* ----------------- STATE  */

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */
  const { dayPost, selectedPostsId } = useCalendarStore((s) => ({
    dayPost: s.dayPost,
    selectedPostsId: s.selectedPostsId,
  }))

  const { setSelectedPostsId, forceUpdate } = useCalendarStore()

  /* ----------------- VARIABLES  */

  const isAllSelected = selectedPostsId.length === dayPost.length

  /* ----------------- METHODS  */
  /**
   * Funzione che gestisce il tracking di mixpanel per la eliminazione di un post
   */
  const handleMixPanel = () => {
    const isBulk = selectedPostsId.length > 1 ? true : false

    for (let i = 0; i < selectedPostsId.length; i++) {
      const postToDelete = dayPost.find((post) => post._id === selectedPostsId[0])

      Tracker.trackEvent(TRACKEREVENTS.POST_DELETED, getMixpanelPostDeletedDataSmall(postToDelete!, isBulk))
    }
  }

  /**
   * Funzione che gestisce la selezione/deselezione di tutti i post
   */
  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedPostsId([])
    } else {
      setSelectedPostsId(dayPost.map((post) => post._id))
    }
  }

  /* ----------------- API CALL  */
  const handleDelete = async () => {
    try {
      const res = await PostV2.deletePosts(selectedPostsId)

      handleMixPanel()
      setSelectedPostsId([])
      forceUpdate()
      showSuccess(T.success.eliminationSuccess)
    } catch (e) {
      console.error(e)
    }
  }

  /* ----------------- USEEFFECT  */

  return (
    <HandleSelectCard isAllSelected={isAllSelected} handleSelectAll={handleSelectAll} handleDelete={handleDelete} />
  )
}
